export default function (ary, property) {
  return (ary || []).map((e) => { return e[property]; });
}
